import React, { useEffect, useState } from "react";
import get from "lodash/get";
import "./style.scss";
import EditIcon from "../../assets/images/icons/pen.svg?react";
import DeleteIcon from "../../assets/images/icons/trash.svg?react";
import SortUp from "../../assets/images/icons/sort-up-1.svg?react";
import SortDown from "../../assets/images/icons/sort-down-1.svg?react";
import EmptyState from "../../assets/images/icons/state-empty.svg";
import cx from "classnames";
import { useLocation } from "react-router-dom";
import { useHistory } from "react-router";
import qs from 'qs';
import filterIcon from "./filter.png";
import {Spinner} from "../index";

const Index = ({
  items = [],
  rowKey = "id",
  columns = [],
  isFetched = false,
  editAction,
  deleteAction,
  visibleEdit = true,
  visibleDelete = true,
  emptyUiText = "Список пуст",
  extraTheadRow,
  hasExtraTheadRow,
  onRowClick = () => {},
}) => {
  const [visibleColumns, setVisibleColumns] = useState([]);

  const location = useLocation();
  const history = useHistory();
  const query = qs.parse(location.search, { ignoreQueryPrefix: true });
  const pageKey = location.pathname;
  const classes = cx("devent-table", !isFetched && "--loading");

  useEffect(() => {
    const storedColumns = JSON.parse(localStorage.getItem("columns")) || {};
    const pageColumns = storedColumns[pageKey];

    if (pageColumns) {
      const updatedColumns = columns
        .map((col) => {
          const storedCol = pageColumns.find(
            (storedCol) => storedCol.dataIndex === col.dataIndex
          );
          return {
            ...col,
            visible: storedCol ? storedCol.visible : true,
          };
        })
        .filter((col) => col.visible !== false);
      setVisibleColumns(updatedColumns);
    } else {
      const initialColumns = columns.map((col) => ({ ...col, visible: true }));
      setVisibleColumns(initialColumns);

      const updatedStorage = {
        ...storedColumns,
        [pageKey]: initialColumns,
      };
      localStorage.setItem("columns", JSON.stringify(updatedStorage));
    }
  }, [columns, pageKey]);

  return (
    <div className={classes}>
      {!isFetched && <Spinner position={'absolute'}/>}
      <table>
        <thead>
          <tr>
            {visibleColumns
              .filter((col) => col.visible !== false)
              .map((col, i) => (
                <th key={i} className={get(col, "className")}>
                  {col.sort ? (
                    <div className="!flex !items-center cursor-pointer">
                      <span
                        onClick={() => {
                          let nextSort;
                          if (query.sort === col.sort) {
                            nextSort = "-" + col.sort;
                          } else if (query.sort === "-" + col.sort) {
                            nextSort = null;
                          } else {
                            nextSort = col.sort;
                          }
                          history.push({
                            search: qs.stringify(
                              { ...query, sort: nextSort },
                              { encode: false }
                            ),
                          });
                        }}
                      >
                        {get(col, "title")}
                      </span>
                      <div className="table-sort-ui">
                        <span
                          className={query.sort === col.sort ? "--active" : ""}
                        >
                          <SortUp />
                        </span>
                        <span
                          className={
                            query.sort === "-" + col.sort ? "--active" : ""
                          }
                        >
                          <SortDown />
                        </span>
                      </div>
                    </div>
                  ) : col.headerIcon ? (
                    <img src={filterIcon} alt="" className="filter-icon" />
                  ) : col.hasSelect ? (
                    <div className="select-container">
                      <div>{get(col, "title")}</div>
                      <select
                        className="filter-select"
                        onChange={(e) => {
                          col.headerFilter(Number(e.target.value));
                          col.setCanUpdate((prev) => !prev);
                        }}
                      >
                        {col.filterOptions &&
                          col.filterOptions.map((option) => (
                            <option key={option.value} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                      </select>
                    </div>
                  ) : (
                    get(col, "title")
                  )}
                </th>
              ))}
            {visibleEdit && editAction && <th className="w-50" />}
            {visibleDelete && deleteAction && <th className="w-50" />}
          </tr>

          {hasExtraTheadRow && extraTheadRow()}
        </thead>
        {items.length > 0 && (
          <tbody>
            {items.map((item, ind) => {
              return (
                <tr key={item[rowKey]}>
                  {visibleColumns
                    .filter((col) => col.visible !== false)
                    .map((col, i) => (
                      <td
                        key={i}
                        className={get(col, "className")}
                        onClick={() => {
                          if (!get(col, "isClickable")) {
                            onRowClick(item);
                          }
                        }}
                      >
                        {col.render(item[col.dataIndex], item, ind)}
                      </td>
                    ))}
                  {visibleEdit && editAction && (
                    <td className="w-50">
                      <span
                        className="action-btn action-btn--info"
                        onClick={() => editAction(item)}
                      >
                        <EditIcon />
                      </span>
                    </td>
                  )}
                  {visibleDelete && deleteAction && (
                    <td className="w-50">
                      <span
                        className="action-btn action-btn--danger"
                        onClick={() => deleteAction(item)}
                      >
                        <DeleteIcon />
                      </span>
                    </td>
                  )}
                </tr>
              );
            })}
          </tbody>
        )}
      </table>
      {isFetched && items.length < 1 && (
        <div className="devent-table__no-data">
          <img src={EmptyState} alt="" />
          {emptyUiText}
        </div>
      )}
    </div>
  );
};

export default Index;
